import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { BaseOverrideNoHidden } from '../../../../BaseOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride('deviationJustificationMessage', {
    _hideLabel: true,
    _component: () => Text,
    _customProps: {
      align: 'center',
      variant: 'h6',
      color: 'primaryGray',
    },
  })
  .nameOverride('retirementDeviationJustificationMessage', {
    _hideLabel: true,
    _component: () => Text,
    _customProps: {
      align: 'center',
      variant: 'h6',
      color: 'primaryGray',
    },
  });
